<template>
  <div class="user-profile user-profile__wrap full-width">
    <div class="ss-breadcrumb">
      <div class="container-hts">
        <ul class="margin-0 p-0">
          <li>
            <router-link :to="{ name: 'user-profile' }">Trang cá nhân</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="container-hts">
      <div class="row mt-5 mb-5">
        <div class="col-lg-8 col-md-8 col-12 info display-flex">
          <div class="img-user">
            <!-- :src="!getUserInfo.avatar != null ? cdnUrl + getUserInfo.avatar :thumbUrl('user-avatar.png')" ? -->
            <img alt="picture"
              :src="!getUserInfo.avatar || getUserInfo.avatar === null ? imgAvatar : `${uploadUrl}/${getUserInfo.avatar}`"
              class="img-lg avatar rounded-circle border" />
          </div>
          <div class="info-user">
            <h3 class="pt-sm-2 pb-1 mb-0 title-color-gray font-sanpro-semibold font-size-24" v-if="getUserInfo">
              {{ getUserInfo.name }} </h3>
            <div class="css-display display-flex-center ">
              <div class="form-group select-status" v-if="authInfo && authInfo.roleCode === rolePupil">
                <select class="form-control" id="status" v-model="classIdUser" @change="handleSelectClass">
                  <option value="0">Lớp - Tất cả</option>
                  <option v-for="(option, index) of getListClass" :key="index" :value="option.classId">{{ option.name }}
                  </option>
                </select>
                <i class="fa fa-angle-down"></i>
              </div>
              <div v-else class="form-group select-status">
                <select class="form-control" id="status" v-model="schoolType" @change="handleSelectClass">
                  <option :value="0">Chọn cấp dạy</option>
                  <option v-for="(option, index) of listTypeSchool" :key="index" :value="option.schoolTypeId">Giáo viên
                    {{ option.name }}</option>
                </select>
                <i class="fa fa-angle-down"></i>
              </div>
              <div class="edit-info">
                <button class="primary-color font-sanpro-semibold font-size-16 color_bg_gray_light btn-edit"
                  v-b-modal.modalEditInfoProfile>Chỉnh sửa thông tin</button>
              </div>
              
            </div>
            <div>
              ID: {{ authInfo.userId }}
              </div>
            <!-- Giáo viên {{getUserInfo.schoolTypeName}} -->
            <div class="ebooks-active display-flex">
              <!-- <div class="ebook-atv"> -->
              <span class="font-sanpro line-clamp title-color-gray"><strong
                  class="font-sanpro-semibold">{{ getUserInfo.numberOfEBooks }}</strong> Sách điện tử đã kích hoạt</span>
              <!-- </div> -->
              <!-- <div class="class-atv"> -->
              <span class="font-sanpro line-clamp title-color-gray"><strong
                  class="font-sanpro-semibold">{{ getUserInfo.numberOfClasses }}</strong> Lớp học đã tham gia</span>
              <!-- </div> -->
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-12" v-if="authInfo && authInfo.roleCode !== 'TEACHER'">
          <div
            class="form-content form-bg-gray-light border-rd-10 col d-flex flex-column flex-sm-row justify-content-between mb-3">
            <div class="text-sm-left">
              <label for="city" class="lbl-name font-size-16 font-sanpro-semibold color-form">Thông tin phụ huynh</label>
              <br />
              <div class="form-section">
                <div class>
                  <label for="firstname" class="lbl-name font-size-16 font-sanpro-semibold color-form width-80">Họ và
                    tên:</label>
                  <label
                    class="font-size-16 font-sanpro title-color-gray">{{ getUserInfo && getUserInfo.parentName ? getUserInfo.parentName : '' }}</label>
                </div>
                <div class>
                  <label for="firstname"
                    class="lbl-name font-size-16 font-sanpro-semibold color-form width-80">Email:</label>
                  <label
                    class="font-size-16 font-sanpro title-color-gray">{{ getUserInfo && getUserInfo.parentEmail ? getUserInfo.parentEmail : '' }}</label>
                </div>
              </div>
            </div>
            <div class="text-center text-sm-right"></div>
          </div>
        </div>
      </div>

      <div class="whole-page">
        <b-tabs content-class="mt-3" v-model="tabIndex">
          <b-tab title="Quá trình học" active v-if="authInfo.roleCode === rolePupil">
            <LearnProcess />
          </b-tab>
          <b-tab title="Sách của tôi">
            <HomeProfile />
          </b-tab>
          <b-tab title="Hoạt động" @click="GetDataActivity">
            <ActivityProfile ref="ActivityProfile" />
            <!-- <UnderConstruction /> -->
          </b-tab>
          <!-- <b-tab title="Lịch">
                    <CalendarProfile />
                  </b-tab> -->
          <b-tab title="Thời khóa biểu">
            <ScheduleProfile />
            <!-- <UnderConstruction /> -->
          </b-tab>
          <!-- <b-tab title="Thông tin" >
                    
                  </b-tab> -->
          <InfoProfile />
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { STORE_KEY } from "../_store/constants";
import { STORE_KEY1 } from "../../classrooms/_store/constants";
import { ROLE_PUPIL } from './../../../store/auth/constants'
import moment from "moment";
import store from "../_store";
import { APP_CONFIG } from "@/utils/constants";
import HomeProfile from "./detail-profile/HomeProfile"
import ActivityProfile from "./detail-profile/ActivityProfile"
import CalendarProfile from "../../classrooms/_components/ViewCalendar"
import InfoProfile from "./detail-profile/InfoProfile"
import ScheduleProfile from "./detail-profile/ScheduleProfile"
import { getAuth } from '@/utils/jwt'
import UnderConstruction from "@/views/pages/UnderConstruction"
import LearnProcess from './detail-profile/LearnProcess'
const imgAvatar = require('@/assets/images/user-avatar.png');
export default {
  name: "UserProfile",
  data() {
    return {
      tabIndex: 0,
      birthDay: '',
      birthMonth: '',
      gender: 0,
      lastName: '',
      firstName: '',
      authInfo: {},
      selectClass: 0,
      selectCity: 0,
      getALLProvice: [],
      classIdUser: 0,
      schoolName: '',
      cityUser: 0,
      emailTeacher: '',
      phoneNumberTeacher: '',
      schoolType: 0,
      listTypeSchool: [],
      url_image: '',
      parentName: '',
      parentEmail: '',
      rolePupil: ROLE_PUPIL,
      nameRoute: this.$route.name,
      cdnUrl: APP_CONFIG.cdnUrl,
      uploadUrl: APP_CONFIG.appUrl,
      imgAvatar
    };
  },
  components: {
    HomeProfile,
    ActivityProfile,
    CalendarProfile,
    InfoProfile,
    ScheduleProfile,
    UnderConstruction,
    LearnProcess
  },
  computed: {
    ...mapGetters({
      getUserInfo: STORE_KEY + "/getUserInfo",
      getBaseInfo: STORE_KEY + "/getBaseInfo",
      getListClass: STORE_KEY + "/getListClass",
      changeClass: STORE_KEY + "/changeClass",
      getParamListelEctricBooks: STORE_KEY + "/getParamListelEctricBooks",

    }),
  },
  watch: {
    getBaseInfo(newVal) {
      if (newVal) {
        this.birthDay = moment(newVal.birthday).format("D");
        this.birthMonth = moment(newVal.birthday).format("M");
        this.birthYear = moment(newVal.birthday).format("YYYY");
        this.gender = newVal.gender;
        this.lastName = newVal.lastName;
        this.firstName = newVal.firstName;
        this.schoolName = newVal.school;
        this.cityUser = newVal.city;
        this.classIdUser = newVal.classId;
        this.phoneNumberTeacher = newVal.phoneNumber;
        this.emailTeacher = newVal.email;
        this.schoolType = newVal.schoolTypeId;
        this.url_image = newVal.avatar;
        this.parentName = newVal.parentName;
        this.parentEmail = newVal.parentEmail
        // this.parentPhoneNumber = newVal.parentPhoneNumber
      }
    },
  },
  created() {
    this.authInfo = getAuth();
    this.getListTypeSchool();
  },
  mounted() {
    this.actionGetUserInfo()
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, [
      "actionGetUserInfo",
      'actionUpdateUserInfo',
      'actionGetListTypeSchool',
      'actionGetBaseInfo',
      'actionGetUserInfo'
    ]),
    ...mapActions(`${STORE_KEY}`, ["actionGetBaseInfo", "actionUpdateUserInfo", "actionSetParamListEctricBooks", "actionGetListClasses", "actionGetAllProvince", "actionGetListTypeSchool", "actionGetUserInfo", 'setChangDislay']),
    ...mapActions(`common`, ["setLoading"]),
    GetDataActivity(){
      this.$refs.ActivityProfile.getDefaultParamActivityList();
    },
    thumbUrl(filename) {
      return require(`@/assets/images/${filename}`);
    },
    moment,
    handleSelectClass() {
      var data = this.birthYear + "-" + this.birthMonth + "-" + this.birthDay;
      this.actionUpdateUserInfo({
        lastName: this.lastName,
        firstName: this.firstName,
        birthday: data,
        gender: this.gender,
        city: this.cityUser,
        school: this.schoolName,
        classId: this.classIdUser,
        email: this.emailTeacher,
        schoolTypeId: this.schoolType,
        phoneNumber: this.phoneNumberTeacher,
        avatar: this.url_image,
        parentName: this.parentName,
        // phoneNumber: this.parentPhoneNumber
      })
        .then(res => {
          if (res.status === "success") {
            this.actionGetBaseInfo();
            this.actionGetUserInfo();
            this.setChangDislay(!this.changeClass)
            this.displayEdit = true;
            this.disabled = true;
            this.$toast.success("Cập nhật thành công");
            this.$bvModal.hide('modalEditInfoProfile')
          }
        });
    },
    getListTypeSchool() {
      this.actionGetListTypeSchool().then(res => {
        if (res && res.data) {
          this.listTypeSchool = res.data
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.ebooks-active,
.form-content {
  display: none !important;
}

.edit-info {
  line-height: 50px;
  margin-left: 20px;
}

.btn-edit {
  height: 30px;
  line-height: 30px;
  border: 0;
  outline: 0;
  border-radius: 20px;
  padding: 0 15px;
}

.line-clamp {
  font-size: 16px;
  padding-top: 0px;
  overflow: hidden;
  line-height: 1.4;
  max-width: 100%;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  display: -webkit-box;
  width: 210;
}

.avatar {
  width: 123px;
  height: 123px;
  margin: 0 30px;
}

.info-user {
  margin-left: 18px;

  .select-status {
    position: relative;
    margin-top: 15px;

    select {
      border: none;
      background: #f3f6fb;
      border-radius: 20px;
      height: 30px;
      font-size: 14px;
      -webkit-appearance: none;
      width: 130px;
    }

    i {
      position: absolute;
      top: 7px;
      left: 114px;
    }
  }

  .ebooks-active {
    margin-top: 20px;

    span:first-child {
      margin-right: 20px;
    }
  }
}

.form-content {
  padding: 13px 15px;
}

@media (max-width: 1024px) {
  .info-user .ebooks-active {
    display: block;

    span {
      margin-right: 0;
      display: block;
    }
  }

  .info-user .ebooks-active span:first-child {
    margin-right: 0px !important;
  }
}

@media screen and (max-width: 991px) {
  .user-profile {
    margin-top: 75px;

    &__wrap {
      padding-bottom: 50px;
    }
  }
}

@media (max-width: 768px) {
  .info-profile__sidebar {
    width: 30%;
  }

  .basic-info__view .gender-list {
    padding: 0px 5px;
  }

  .css-display {
    display: block;

    .select-status {
      margin-bottom: 0;
    }

    .edit-info {
      line-height: 50px;
      margin: 0px;
    }
  }
}

@media (max-width: 425px) {
  .info {
    display: block !important;

    .info-user {
      text-align: center;
      margin: 20px 0;

      .select-status {
        position: relative;
        margin-top: 15px;
        text-align: -webkit-center;

        i {
          left: 225px;
        }
      }
    }
  }

  .avatar {
    margin: 0 auto;
    display: block;
  }

  .user-profile {
    &__wrap {
      display: block;
    }

    &__sidebar {
      width: 100%;
      margin-right: 0;
    }
  }

  .w-67 {
    width: 100%;
    margin-top: 18px;
  }
}

@media (max-width: 375px) {
  .info-user .select-status i {
    left: 200px !important;
  }
}

@media (max-width: 320px) {
  .info-user .select-status i {
    left: 175px !important;
  }
}</style>
